const ALIASES = {
  'zh-cn': 'zh-hans', 'zh-hans': 'zh-hans', cn: 'zh-hans',
  'zh-tw': 'zh-hant', 'zh-hant': 'zh-hant', tw: 'zh-hant',
  en: 'en', vi: 'vi', vn: 'vi', id: 'id',
};

export const normalizeAssessmentLanguage = (value, fallback = 'zh-hans') => (
  ALIASES[String(value || '').toLowerCase()] || fallback
);

export const uiLanguage = (value) => ({
  'zh-hans': 'zh-CN', 'zh-hant': 'zh-TW', en: 'en', vi: 'vi', id: 'id',
}[normalizeAssessmentLanguage(value)]);

export const LANGUAGE_OPTIONS = [
  ['zh-hans', '简体中文'], ['zh-hant', '繁體中文'], ['en', 'English'],
  ['vi', 'Tiếng Việt'], ['id', 'Bahasa Indonesia'],
];

export const isAdultAssessment = (type) => ['adult14', 'adult14_hr'].includes(type);

// Report language has its own default; it never follows the answer language.
export const assessmentMetadata = (context = {}) => ({
  assessment_language: normalizeAssessmentLanguage(context.assessment_language || context.defaultLang),
  report_language: normalizeAssessmentLanguage(context.report_language, 'zh-hans'),
  ...Object.fromEntries(['question_bank_version', 'question_bank_checksum', 'scoring_version']
    .filter(key => context[key]).map(key => [key, context[key]])),
});

export const responseMetadata = (data = {}) => {
  const bank = data.question_bank || {};
  return {
    ...(bank.version || data.question_bank_version ? { question_bank_server_bound: true } : {}),
    ...(data.assessment_language || bank.language || bank.lang
      ? { assessment_language: normalizeAssessmentLanguage(data.assessment_language || bank.language || bank.lang) } : {}),
    ...(data.report_language ? { report_language: normalizeAssessmentLanguage(data.report_language) } : {}),
    ...Object.fromEntries([
      ['question_bank_version', bank.version || data.question_bank_version],
      ['question_bank_checksum', bank.checksum || data.question_bank_checksum],
      ['scoring_version', bank.scoring_version || data.scoring_version],
    ].filter(([, value]) => value)),
  };
};

export const addMetadataToParams = (params, context) => {
  Object.entries(assessmentMetadata(context)).forEach(([key, value]) => params.set(key, value));
  return params;
};
